import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 500px;

  z-index: 1;
  > aside {
    display: flex;
    flex-direction: row;

    > button.active {
      border: 2px solid rgb(0, 100, 150);
    }
    > button {
      padding: 10px;
      background: #fff;
      border-radius: 8px;
      margin: 20px;
      max-width: 200px;
      position: relative;
      > img {
        width: 100%;
        max-width: 200px;
      }

      > span {
        font-weight: bold;
      }

      > input {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        opacity: 0.01;
      }
    }
  }

  @media (max-width: 450px) {
    padding-left: 30px;
    padding-right: 30px;
    width: 100%;
  }
`;
